/* istanbul ignore file */
export * from './InspiringSearchTeaserCard';
